import styled from 'styled-components';
import { Token } from '@usealloy/component-library';

import { GRAY } from '~/constants';

export const CurrentTransaction = styled.div<{ color: string }>`
  width: 100%;

  > div {
    width: 100%;
    background-color: ${p => p.color};
  }
`;

export const CurrentTransactionTimeline = styled.div`
  width: 100%;
`;

export const CurrentTransactionBankAccount = styled.div`
  width: 100%;

  > div {
    max-width: none;
  }
`;

export const CurrentTransactionExternalId = styled(Token)`
  &&&& {
    width: 0;
    min-width: 100%;
    height: var(--cl-font-size-2);
    padding: 0;
    border: none;
    font-size: var(--cl-font-size-2);
    font-family: inherit;
    justify-content: flex-start;
    background: transparent;

    pre {
      color: var(--cl-gray-700);
      font-family: inherit;
    }

    svg {
      color: ${GRAY.gray700};
    }
  }
`;
